import { useState, useEffect } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Select, Options } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Text } from '../../components/Text';
import { Button, Col, Row, Pagination, Modal } from 'react-bootstrap';
import Search from '../../components/Search';
import { Table, TBody, TCell, TGroup, THeader, TRow, ThCell } from '../../components/Table/Table';
import { FillPlus } from '../../components/Icons';
import { Title } from '../../components/Title';
import './style.css';
import React from 'react';
import AlertMessage from '../../components/Alert';

export function Trabalhadores() {
    const [isLoading, setIsLoading] = useState(true);

    const [workers, setWorkers] = useState([]); // Estado para armazenar os funcionários

    const [currentPage, setCurrentPage] = useState(1);
    const [workersPerPage, setWorkersPerPage] = useState(20);
    const [workersPerPageOptions] = useState([5, 10, 15, 20, 50, 100]);

    const [searchQuery, setSearchQuery] = useState('');
    const [currentFilteredWorkers, setCurrentFilteredWorkers] = useState([]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);

    const [idSelected, setIdSelected] = useState('');

    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });


    // Calcula o índice do primeiro e do último funcionário na página atual
    const indexOfLastWorker = currentPage * workersPerPage;
    const indexOfFirstWorker = indexOfLastWorker - workersPerPage;

    const currentWorkers = workers.slice(indexOfFirstWorker, indexOfLastWorker);

    const filteredWorkers = workers.filter((worker: any) => {

        const cpfClean = worker.cpf.replace(/[\.-]/g, ''); // Remove '.' e '-'

        return (
            worker.nome.toLowerCase().includes(searchQuery.toLowerCase()) ||
            cpfClean.includes(searchQuery) ||
            worker.id.toString().includes(searchQuery)
        );
    });

    useEffect(() => {
        const indexOfLastFilteredWorker = currentPage * workersPerPage;
        const indexOfFirstFilteredWorker = indexOfLastFilteredWorker - workersPerPage;
        const newCurrentFilteredWorkers = filteredWorkers.slice(indexOfFirstFilteredWorker, indexOfLastFilteredWorker);

        setCurrentFilteredWorkers(newCurrentFilteredWorkers);
    }, [currentPage, workersPerPage, filteredWorkers]);

    const loadWorkers = async () => {
        try {
            const response = await api.get('buscar-trabalhadores');
            setWorkers(response.data);
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    };

    const handleEmployeesPerPageChange = (value: any) => {
        setWorkersPerPage(Number(value));
        setCurrentPage(1); // Volta para a primeira página ao mudar a quantidade por página
    };



    // Load companies initially
    useEffect(() => {
        loadWorkers();
    }, []);

    /*paginação*/
    const paginationItems = () => {
        let items = [];
        const totalPaginas = Math.ceil(filteredWorkers.length / workersPerPage); // Use filteredEmployees para calcular o total de páginas

        // Primeira página
        if (currentPage > 2) {
            items.push(
                <Pagination.Item
                    key="first"
                    onClick={() => setCurrentPage(1)}
                >
                    1
                </Pagination.Item>
            );
        }

        // Reticências antes da página atual, se necessário
        if (currentPage > 3) {
            items.push(<Pagination.Ellipsis key="startEllipsis" disabled />);
        }

        // Página anterior à atual, se aplicável
        if (currentPage > 1) {
            items.push(
                <Pagination.Item
                    key={currentPage - 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                >
                    {currentPage - 1}
                </Pagination.Item>
            );
        }

        // Página atual
        items.push(
            <Pagination.Item
                key={currentPage}
                active
            >
                {currentPage}
            </Pagination.Item>
        );

        // Página seguinte à atual, se aplicável
        if (currentPage < totalPaginas) {
            items.push(
                <Pagination.Item
                    key={currentPage + 1}
                    onClick={() => setCurrentPage(currentPage + 1)}
                >
                    {currentPage + 1}
                </Pagination.Item>
            );
        }

        // Reticências depois da página atual, se necessário
        if (currentPage < totalPaginas - 2) {
            items.push(<Pagination.Ellipsis key="endEllipsis" disabled />);
        }

        // Última página
        if (currentPage < totalPaginas - 1) {
            items.push(
                <Pagination.Item
                    key="last"
                    onClick={() => setCurrentPage(totalPaginas)}
                >
                    {totalPaginas}
                </Pagination.Item>
            );
        }

        return items;
    };

    const handleSearchChange = (value: string) => {
        setSearchQuery(value);
        setCurrentPage(1);
    };

    const calculateAge = (birthdate: string) => {
        const today = new Date();
        const birthDate = new Date(birthdate);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    const showModal = (id: any) => {
        setIdSelected(id)
        setShow(true)
    }

    const handleExclude = async () => {
        try {
            await api.post(`trabalhadores/excluir/${idSelected}`);
            loadWorkers();
            setAlert({ show: true, message: 'Trabalhador excluído com sucesso!', variant: 'success' });
        } catch (error) {
            setAlert({ show: true, message: 'Erro ao excluir o trabalhador', variant: 'danger' });
        }
        handleClose();
    };


    return (
        <div>
            <Sidebar />
            <Header route='./' />
            <Main>
                <>
                    <CardContent>
                        <Row className='my-4'>
                            <Title text="Trabalhadores" />
                            <Col md={8}>
                                <Button className='newbutton' href={`trabalhadores/cadastrar/`}><FillPlus /> Novo Trabalhador</Button>
                            </Col>
                            <Col md={4}>
                                <Search placeHolder="Procure pelo Nome ou CPF" onChange={handleSearchChange} />
                            </Col>
                        </Row>
                        <Row className='mb-4'>
                            <Col sm={10} className='my-2 d-flex align-items-end'>
                                <span>Página {currentPage} de {Math.ceil(workers.length / workersPerPage)}</span>

                            </Col>
                            <Col sm={2} className='my-2 d-flex justify-content-end'>
                                <Select id='employeesPerPageSelect' onSelect={handleEmployeesPerPageChange}>
                                    {workersPerPageOptions.map((option) => (
                                        <Options
                                            key={option}
                                            value={option}
                                            name={`${option} por página`}
                                            selected={option === workersPerPage}
                                        />
                                    ))}
                                </Select>

                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden', marginTop: '30px' }}>
                                    <div style={{ overflow: 'auto' }}>
                                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                            <thead>
                                                <tr style={{ backgroundColor: '#007bff', color: 'white', textAlign: 'center' }}>
                                                    <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>CÓD</th>
                                                    <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Nome</th>
                                                    <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>CPF</th>
                                                    <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>RG</th>
                                                    <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>IDADE</th>
                                                    <th style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>Ações</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {workers.length > 0 ? (
                                                    workers.map((worker: any) => (
                                                        <React.Fragment key={worker.id}>
                                                            <tr style={{ textAlign: 'center' }}>
                                                                <td style={{ padding: '15px', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{worker.id}</td>
                                                                <td style={{ padding: '15px', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{worker.nome.toUpperCase()}</td>
                                                                <td style={{ padding: '15px', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{worker.cpf}</td>
                                                                <td style={{ padding: '15px', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{worker.rg}</td>
                                                                <td style={{ padding: '15px', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{worker.data_nascimento ? calculateAge(worker.data_nascimento) : ' '}</td>
                                                                <td style={{ padding: '15px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                                                    <Button variant='outline-main' href={`trabalhadores/editar/${worker.id}`} style={{ fontSize: '13px' }}>Editar</Button>
                                                                    <Button
                                                                        variant='outline-danger'
                                                                        onClick={() => {
                                                                            showModal(worker.id);
                                                                        }}
                                                                    >
                                                                        Excluir
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        </React.Fragment>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={6} style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>
                                                            Não há dados para serem mostrados
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </Col>
                            <Col className='d-flex justify-content-center mt-4'>
                                <div className="pagination">
                                    <Pagination>
                                        {paginationItems()}
                                    </Pagination>
                                </div>
                            </Col>
                        </Row>
                    </CardContent>
                    <Modal show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmação de exclusão</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>Você tem certeza que deseja excluir este item?</Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Cancelar
                            </Button>
                            <Button variant="primary" onClick={handleExclude}>
                                Confirmar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <AlertMessage
                        show={alert.show}
                        message={alert.message}
                        variant={alert.variant}
                        onClose={() => setAlert({ ...alert, show: false })}
                    />
                </>
            </Main>
        </div >
    );
}